import { BaseResponse } from '../../../../../../types/api/api.types';
import { BOOSTS_ENDPOINTS } from '../../../../../../utils/api/endpoints/boostsEndpoints';
import { AddBoostQueryParams } from './DashboardResultsTable.types';

const ADD_PREFIX = '[addBoostQuery]';

export const ADD_BOOST_QUERY_KEY = 'ADD_BOOST';

export const addBoostQuery = async (data: AddBoostQueryParams) => {
  console.log(ADD_PREFIX, `Adding boost to history...`);
  const response = await BOOSTS_ENDPOINTS.addHistory(data);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(ADD_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(ADD_PREFIX, `Added boost to history.`);
  return json as BaseResponse;
};

const REMOVE_PREFIX = '[removeBoostQuery]';

export const REMOVE_BOOST_QUERY_KEY = 'REMOVE_BOOST';

export const removeBoostQuery = async (boostHistoryId: number) => {
  console.log(REMOVE_PREFIX, `Removing boost from history...`);
  const response = await BOOSTS_ENDPOINTS.removeHistory(boostHistoryId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(REMOVE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(REMOVE_PREFIX, `Removed boost from history.`);
  return json as BaseResponse;
};
